import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {ForecastCollection} from './forecast-collection';
import {HttpClient, HttpParams} from '@angular/common/http';
import { formatDate } from '@angular/common';
import {map} from 'rxjs/operators';
import * as classTransformer from 'class-transformer';
import {Forecast} from './forecast';
import {PlanningParameter} from '../planning-parameter/planning-parameter';
import {Manufacturer} from '../manufacturer/manufacturer';
import {PlanningParameterService} from '../planning-parameter/planning-parameter.service';

@Injectable({
    providedIn: 'root',
})
export class ForecastService {

    constructor(
        private httpClient: HttpClient,
    ) {
    }

    static buildIri(forecast: Forecast): string {
        return `/cpe/forecasts/${forecast.id}`;
    }

    public getAll(manufacturer: Manufacturer, monthStart: Date, monthEnd: Date): Observable<ForecastCollection> {
        const params = new HttpParams()
            .set('planningParameter.manufacturer', manufacturer.id)
            .set('from', formatDate(monthStart, 'yyyy-MM', 'de-LU'))
            .set('to', formatDate(monthEnd, 'yyyy-MM', 'de-LU'));

        return this.httpClient
            .get('/forecasts', {params})
            .pipe(map((result: any) => this.hydrateCollection(result)));
    }

    public getAllByPlanningParameter(planningParameter: PlanningParameter, monthStart: Date, monthEnd: Date): Observable<ForecastCollection> {
        const params = new HttpParams()
            .set('planningParameter', planningParameter.id)
            .set('from', formatDate(monthStart, 'yyyy-MM', 'de-LU'))
            .set('to', formatDate(monthEnd, 'yyyy-MM', 'de-LU'));

        return this.httpClient
            .get('/forecasts', {params})
            .pipe(map((result: any) => this.hydrateCollection(result)));
    }

    public getForecast(forecastId: string): Observable<Forecast> {
        return this.httpClient
            .get('/forecasts/' + forecastId)
            .pipe(map(result => classTransformer.plainToInstance(Forecast, result)));
    }

    public createNewForecast(planningParameter: PlanningParameter, month: number, year: number): Observable<Forecast> {
        const params = {
            month: month,
            year: year,
            planningParameter: PlanningParameterService.buildIri(planningParameter),
        };

        return this.httpClient
            .post('/forecasts', params)
            .pipe(map((forecastData: any) => classTransformer.plainToInstance(Forecast, forecastData as Record<string, unknown>)));
    }

    private hydrateCollection(result: any): ForecastCollection {
        const collection = new ForecastCollection();
        collection.setTotalItems(result['totalItems']);
        collection.setForecasts(
            result['member'].map((forecastData: any) =>
                classTransformer.plainToInstance(Forecast, forecastData, {excludeExtraneousValues: false})
            )
        );

        return collection;
    }
}
